import actionTypes from '../actionTypes';

export function requestLogin({username, password, skinId, token}) {
  return {
    type: actionTypes.LOGIN_REQUEST,
    value: { username, password, skinId, token },
  };
}

export function requestRegister({username, password, parentId}) {
  return {
    type: actionTypes.REGISTER_REQUEST,
    value: { username, password, parentId },
  };
}

export function successLogin( authData ) {
  return {
    type: actionTypes.LOGIN_SUCCESS,
    authData
  };
}

export function failLogin( authData ) {
  return {
    type: actionTypes.LOGIN_FAILURE,
    authData
  };
}

export function checkAuthentication() {
  return {
    type: actionTypes.CHECK_AUTHENTICATION
  };
}

export function logout() {
  return {
    type: actionTypes.USER_LOGOUT,
  };
}


export function requestRecovery({email}) {
  return {
    type: actionTypes.PASSWORD_RECOVERY_REQUEST,
    value: { email },
  };
}
export function successRecovery( authData ) {
  return {
    type: actionTypes.PASSWORD_RECOVERY_SUCCESS,
    authData
  };
}

export function failRecovery( authData ) {
  return {
    type: actionTypes.PASSWORD_RECOVERY_FAILURE,
    authData
  };
}